import { useState } from "react";
import useFetch from "../../../../hooks/useFetch";

export default function usePracticeSession() {
  const { request, loading } = useFetch();
  const [data, setData] = useState([]);

  const fetchData = async (url) => {
    const res = await request(url);
    if (res?.data) {
      setData(res.data.practiseSessionStats);
    }
  };

  return { data, loading, fetchData };
}